import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

import { Layout, ProtectedRoute } from '../components/layout';
import {
  AuthCallback,
  Login,
  TenantList,
  TenantDetail,
  NotFound,
  ClioCallback,
  ReconciliationRuns,
  ReconciliationRunDetail,
  DataReplicationConfiguration,
  JuniperData,
  PrivilegedAccess,
} from '../pages';
import { TemplateStudioPage } from '../features/template-studio';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/tenants" replace /> },
      { path: 'tenants', element: <TenantList /> },
      { path: 'tenants/:tenantId', element: <TenantDetail /> },
      { path: 'replication', element: <DataReplicationConfiguration /> },
      { path: 'reconciliation', element: <ReconciliationRuns /> },
      { path: 'reconciliation/:runId', element: <ReconciliationRunDetail /> },
      { path: 'juniper-data', element: <JuniperData /> },
      { path: 'privileged-access', element: <PrivilegedAccess /> },
      { path: 'templates', element: <TemplateStudioPage /> },
      { path: 'templates/*', element: <TemplateStudioPage /> },
    ],
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/auth/callback',
    element: <AuthCallback />,
  },
  {
    path: '/auth/clio/callback',
    element: <ClioCallback />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
